import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class StaticInfoService {
  private staticInfo: any = null;

  constructor() { }

  setStaticInfo(info: any): void {
    this.staticInfo = info;
  }

  getStaticInfo(): any {
    return this.staticInfo;
  }

  hasStaticInfo(): boolean {
    return this.staticInfo !== null;
  }
}
